import * as locations from '@wix/auto_sdk_business-tools_locations';
import * as siteProperties from '@wix/auto_sdk_business-tools_site-properties';

export { locations, siteProperties };
